/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteSkillInput = {
    id?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteSkillMutationVariables = {
    input: DeleteSkillInput;
};
export type deleteSkillMutationResponse = {
    readonly deleteSkill: {
        readonly deletedSkillId: string | null;
    } | null;
};
export type deleteSkillMutation = {
    readonly response: deleteSkillMutationResponse;
    readonly variables: deleteSkillMutationVariables;
};



/*
mutation deleteSkillMutation(
  $input: DeleteSkillInput!
) {
  deleteSkill(input: $input) {
    deletedSkillId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteSkillInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteSkillPayload",
    "kind": "LinkedField",
    "name": "deleteSkill",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedSkillId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteSkillMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteSkillMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteSkillMutation",
    "operationKind": "mutation",
    "text": "mutation deleteSkillMutation(\n  $input: DeleteSkillInput!\n) {\n  deleteSkill(input: $input) {\n    deletedSkillId\n  }\n}\n"
  }
};
})();
(node as any).hash = '9b7a322828aa75a0e7b48916e50ad285';
export default node;
